import axios from 'axios';
import { config as _config } from 'CONFIG';
import user from '@/api/user';
import store from '@/store';
import router from '@/router';
import { delay } from '@/common/js/utils';
import { requestToApp } from '@/api/app';

/**
 * http设置相关
 * axios相关
 * 参考https: //github.com/axios/axios/blob/master/README.md
 */

class HttpManager {

    constructor () {

        axios.defaults.baseURL = _config.baseUrl + _config.version;
        axios.defaults.timeout = 30000;
        this.frequency = {

            approvePayment: {

                value: 0.5

            },
            cancelOwnedSubscription: {

                value: 0.5

            },
            cancelPayment: {

                value: 0.5

            },
            createPayment: {

                value: 0.25

            },
            createSubscription: {

                value: 0.2

            },
            previewCancelOwnedSubscription: {

                value: 1

            },
            previewSubscription: {

                value: 1

            }

        };
        this.interceptors();

    }

    interceptors () {

        let _this = this;
        axios.interceptors.request.use( async config => {

            if ( _config.client !== 'IOS' && _config.client !== 'Android' ) {

                let requiresAuth = router.currentRoute.meta.requiresAuth;

                /**
                 * 如果没有登录且当前页面需要登录，则跳转到登录页面
                 */

                if ( !user.accuontCenterIsLogined() && requiresAuth ) {

                    user.goToAccountCenter( requiresAuth );

                }

                /**
                 * 如果token过期了，则先刷新token
                 */

                if ( !config.url.includes( '/oauth2/token/' ) && config.headers.Authorization && !user.tokenValid()) {

                    try {

                        await user.getToken();
                        user.refreshHeader();

                    } catch ( err ) {

                        console.error( err );

                    }

                }

            }

            /**
             * reolink 的接口不接受Authorization请求头
             */
            if ( config.baseURL.includes( _config.reolink )) {

                delete config.headers.Authorization;

            }

            /**
             * 接口调用频率控制
             */
            let frequencyKey = config.frequency;
            if ( frequencyKey && _this.frequency[ frequencyKey ] ) {

                let { lastTriggerAt = 0, value } = _this.frequency[ frequencyKey ];
                let now = new Date().getTime();
                let dis = lastTriggerAt + ( 1000 / value ) - now;
                if ( dis > 0 ) {

                    await delay( dis );

                }

            }
            return config;

        }, err => console.error( `err ${err}` ));

        axios.interceptors.response.use( response => {

            let frequencyKey = response.config.frequency;
            if ( frequencyKey && _this.frequency[ frequencyKey ] ) {

                _this.frequency[ frequencyKey ].lastTriggerAt = new Date().getTime();

            }

            return response;

        }, async err => {

            console.log( err + '' );
            try {

                let code = err.response.data.error.code;
                let requiresAuth = router.currentRoute.meta.requiresAuth;
                /**
                 * 8213: forced_logout
                 * 12308: error when get token (Auth header invalid)
                 */
                if ( _config.platform === 'web' ) {

                    if ( code === 12308 && requiresAuth ) {

                        user.clearToken();
                        user.goToAccountCenter( requiresAuth );

                    } else if ( code === 8213 && requiresAuth ) {

                        await user.getToken();
                        user.refreshHeader();
                        store.commit( 'LOGOUT_FORCED', true );

                    }

                } else {

                    if ( code === 12308 || code === 8213 || code === 8198 ) {

                        store.commit( 'LOGOUT_FORCED', true );
                        const refreshAppToken = ( data ) => {

                            console.log( 'refresh app token' );
                            data = JSON.parse( data );
                            user.setValue( 'accessToken', data.token );
                            user.refreshHeader();

                        };
                        requestToApp( 'refreshToken', undefined, refreshAppToken );

                    }

                }

            } catch ( err ) {

                console.error( err );

            }
            return Promise.reject( err );

        });

    }

    /**
     * http request method
     */
    get ( url, option ) {

        return axios.get( url, option );

    }

    post ( url, data, option ) {

        return axios.post( url, data, option );

    }

    delete ( url, option ) {

        return axios.delete( url, option );

    }

    put ( url, data, option ) {

        return axios.put( url, data, option );

    }

    patch ( url, data, option ) {

        return axios.patch( url, data, option );

    }

    all ( request ) {

        return axios.all( request );

    }

    setHeader ( key, value ) {

        axios.defaults.headers[key] = `${value}`;

    }

    /**
     * http request
     */
    httpRequest ( opts ) {

        let method = opts.method;

        let config = {};

        if ( opts.config ) {

            config = opts.config;

        }

        switch ( method ) {

            case 'GET':
                return axios.get( opts.url, config );
            case 'POST':
                return axios.post( opts.url, opts.data, config );
            case 'DELETE':
                return axios.delete( opts.url, config );
            case 'PUT':
                return axios.put( opts.url, opts.data, config );
            case 'PATCH':
                return axios.patch( opts.url, opts.data, config );
            case 'ALL':
                return axios.all( opts.request );

        }

    }

}
const httpManager = new HttpManager();
export { httpManager };



// WEBPACK FOOTER //
// ./src/common/js/HttpManager.js